import { __assign } from "tslib";
export var parseQueryParams = function (query) {
    if (query === void 0) { query = ''; }
    if (!query.includes('?')) {
        return {};
    }
    var hashes = query.slice(query.indexOf("?") + 1).split("&");
    return hashes.reduce(function (acc, hash) {
        var _a;
        var _b = hash.split("="), key = _b[0], val = _b[1];
        return key
            ? __assign(__assign({}, acc), (_a = {}, _a[decodeURIComponent(key)] = decodeURIComponent(val), _a)) : acc;
    }, {});
};
export var encodeQueryParams = function (params) {
    var encodedParams = Object.entries(params).map(function (_a) {
        var key = _a[0], value = _a[1];
        return handleValues(key, value);
    });
    return "?" + encodedParams.join('&');
};
export var addQueryParams = function (url, queryParams) {
    if (url === void 0) { url = ''; }
    var params = Object.entries(queryParams)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return (!Object.is(value, undefined) ? handleValues(key, value) : undefined);
    })
        .filter(function (entry) { return !Object.is(entry, undefined); });
    if (!params.length) {
        return url;
    }
    return "" + url + (url.includes('?') ? '&' : '?') + params.join('&');
};
var handleValues = function (key, value) {
    if (Array.isArray(value)) {
        return value.map(function (val) { return encodeURIComponent(key) + "=" + encodeURIComponent(val); }).join('&');
    }
    else {
        return encodeURIComponent(key) + "=" + encodeURIComponent(value);
    }
};
export var removeQueryParam = function (url, param) {
    if (url === void 0) { url = ''; }
    var params = parseQueryParams(url);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete params[param];
    return "" + url.split('?')[0] + (Object.keys(params).length ? encodeQueryParams(params) : '');
};
export var prependHTTP = function (url) { return url && (/^https?:\/\/.+$/i.test(url) ? url : "http://" + url); };
export var stringifyParams = function (params) {
    var stringParams = {};
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        return (stringParams[key] = value === null || value === void 0 ? void 0 : value.toString());
    });
    return stringParams;
};
//# sourceMappingURL=url.js.map